import { Outlet } from 'react-router-dom';

// project import
import RouteGuard from 'routes/RouteGuard';

// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout() {
  return (
    <RouteGuard guest>
      <Outlet />
    </RouteGuard>
  );
}
